// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSchedule_root__ejSgL"};